import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_matricespells} from "../_signals/s_char";
import {ICharMatriceSpell} from "../_interfaces/ICharMatriceSpell";

export const MatricespellsGet = (cid: string) => {
    fetch(apiAddress + "/char/matricespells/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                console.log('BESpells get reponse', data);
                if (data.hasOwnProperty('result')) {
                    s_char_matricespells.value = (data.result as ICharMatriceSpell[])
                }
            }
        )
        .catch((reason => {
            console.log('BESpells get catch', reason);
        }))
}

export const MatricespellsCreate = (spell: ICharMatriceSpell) => {
    fetch(apiAddress + "/char/matricespells/", createOptions('CREATE', spell))
        .then((res) => res.json())
        .then((data) => console.log('BESpells create reponse', data))
        .catch((reason => console.log('BESpells create catch', reason)))
}

export const MatricespellsUpdate = (spell: ICharMatriceSpell) => {
    fetch(apiAddress + "/char/matricespells/", createOptions('UPDATE', spell))
        .then((res) => res.json())
        .then((data) => console.log('BESpells update response', data))
        .catch((reason => console.log('BESpells update catch', reason)))
}

export const MatricespellsDelete=(spell: ICharMatriceSpell)=> {
    fetch(apiAddress + "/char/matricespells/", createOptions('DELETE', spell))
        .then((res) => res.json())
        .then((data) => console.log('BESpells delete response', data))
        .catch((reason => console.log('BESpells delete catch', reason)))
}